import "./AnswerComponent.scss";
import {IOnInit} from "angular";
import {QuizQuestionComponentController} from "../question/QuizQuestionComponent";

export const AnswerComponent = "tfAnswer";

export function answerComponent() {
    return {
        templateUrl: "app/components/quiz/components/answer/AnswerComponent.html",
        transclude: true,
        require: {
            question: "^^tfQuizQuestion"
        },
        bindings: {
            name: "@"
        },
        controllerAs: "ctrl",
        controller: AnswerComponentController
    };
}

export class AnswerComponentController implements IOnInit {

    public name: string;

    public question: QuizQuestionComponentController;

    private isSelected = false;
    private isDisabled = false;

    public $onInit(): void {
        this.question.register(this);
    }

    public clicked() {
        if (!this.isDisabled) {
            if (this.isSelected) {
                this.question.deselect(this);
            } else {
                this.question.select(this);
            }
        }
    }

    public set selected(selected: boolean) {
        this.isSelected = selected;
    }

    public get selected(): boolean {
        return this.isSelected;
    }

    public set disabled(disabled: boolean) {
        this.isDisabled = disabled;
    }

    public get disabled(): boolean {
        return this.isDisabled;
    }
}
